var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDfinity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-1 -1 107.42470599999999 54.6597",
    width: 103.42,
    height: 50.66,
    className: "inline w-8 h-8 ml-1",
    "data-v-45c16e28": "",
    "data-v-5e337368": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    "data-v-45c16e28": ""
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.62 9.14C56.48 11.99 53.72 15.07 51.71 17.53C51.71 17.53 54.95 21.18 58.49 25.09C60.41 22.72 63.17 19.51 66.36 16.61C72.26 11.2 76.1 10.11 78.33 10.11C86.64 10.11 93.37 16.92 93.37 25.35C93.37 33.7 86.64 40.51 78.33 40.6C77.94 40.6 77.46 40.55 76.89 40.42C79.29 41.52 81.92 42.31 84.37 42.31C99.58 42.31 102.55 32.03 102.72 31.28C103.16 29.39 103.42 27.42 103.42 25.4C103.38 11.38 92.15 0 78.33 0C72.56 0 66.27 3.08 59.62 9.14Z",
    id: "a2oTCciHwU",
    "data-v-45c16e28": ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientc2rIvyDhN",
    gradientUnits: "userSpaceOnUse",
    x1: 65.17,
    y1: 3.67,
    x2: 99.9,
    y2: 39.44,
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "21%",
    "data-v-45c16e28": "",
    style: {
      stopColor: "rgb(241, 90, 36)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68.41000000000001%",
    "data-v-45c16e28": "",
    style: {
      stopColor: "rgb(251, 176, 59)",
      stopOpacity: 1
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 41.52C46.95 38.66 49.7 35.59 51.71 33.13C51.71 33.13 48.48 29.48 44.94 25.57C43.01 27.94 40.26 31.15 37.07 34.05C31.17 39.41 27.28 40.55 25.09 40.55C16.79 40.55 10.05 33.74 10.05 25.31C10.05 16.96 16.79 10.15 25.09 10.06C25.48 10.06 25.97 10.11 26.53 10.24C24.13 9.14 21.51 8.35 19.06 8.35C3.85 8.35 0.87 18.63 0.7 19.38C0.26 21.27 0 23.24 0 25.26C0 39.28 11.23 50.66 25.09 50.66C30.86 50.66 37.16 47.58 43.8 41.52Z",
    id: "aFWcwFIax",
    "data-v-45c16e28": ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientaIMror5Zz",
    gradientUnits: "userSpaceOnUse",
    x1: 38.22,
    y1: 46.97,
    x2: 3.5,
    y2: 11.2,
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "21%",
    "data-v-45c16e28": "",
    style: {
      stopColor: "rgb(237, 30, 121)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "89.29%",
    "data-v-45c16e28": "",
    style: {
      stopColor: "rgb(82, 39, 133)",
      stopOpacity: 1
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 8.57C5.24 8.23 1.16 18.1 0.81 19.37C3.47 8.3 13.37 0.04 25.14 0C34.73 0 44.43 9.21 51.59 17.53C51.6 17.51 51.61 17.5 51.62 17.49C51.62 17.49 54.86 21.13 58.4 25.04C58.4 25.04 62.42 29.7 66.71 33.79C68.37 35.37 76.45 41.74 84.23 41.96C98.49 42.36 102.42 31.94 102.64 31.15C100.02 42.27 90.09 50.57 78.29 50.62C68.69 50.62 58.99 41.4 51.8 33.08C51.78 33.1 51.77 33.11 51.76 33.13C51.76 33.13 48.52 29.48 44.98 25.57C44.98 25.57 40.96 20.91 36.68 16.83C35.01 15.25 26.88 8.79 19.1 8.57ZM0.81 19.37C0.8 19.4 0.79 19.43 0.79 19.46C0.79 19.44 0.8 19.41 0.81 19.37Z",
    id: "e1RZG6bOc",
    "data-v-45c16e28": ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("g", {
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2oTCciHwU",
    opacity: 1,
    fill: "url(#gradientc2rIvyDhN)",
    "data-v-45c16e28": ""
  }), /*#__PURE__*/React.createElement("g", {
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2oTCciHwU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0,
    "data-v-45c16e28": ""
  }))), /*#__PURE__*/React.createElement("g", {
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFWcwFIax",
    opacity: 1,
    fill: "url(#gradientaIMror5Zz)",
    "data-v-45c16e28": ""
  }), /*#__PURE__*/React.createElement("g", {
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFWcwFIax",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0,
    "data-v-45c16e28": ""
  }))), /*#__PURE__*/React.createElement("g", {
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1RZG6bOc",
    opacity: 1,
    fill: "#29abe2",
    fillOpacity: 1,
    "data-v-45c16e28": ""
  }), /*#__PURE__*/React.createElement("g", {
    "data-v-45c16e28": ""
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1RZG6bOc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0,
    "data-v-45c16e28": ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfinity);
export default __webpack_public_path__ + "static/media/dfinity.583ab84ba16070ca501453d1e291dff4.svg";
export { ForwardRef as ReactComponent };